module.exports = __webpack_public_path__ + "img/prize1_active.5f42b4e.png";